var _a;
import * as deviceFrames from './deviceFrames';
export var STATUS_BAR_BLACK = '0';
export var STATUS_BAR_BLACK_CLEAR = '1';
export var STATUS_BAR_BLACK_WHITE_CLEAR = '2';
export var STATUS_BAR_TYPE_MAP = (_a = {},
    _a[STATUS_BAR_BLACK] = 'black',
    _a[STATUS_BAR_BLACK_CLEAR] = 'black-translucent',
    _a[STATUS_BAR_BLACK_WHITE_CLEAR] = 'black-translucent',
    _a);
var DEFAULT_STATUS_BAR_HEIGHT = 20;
var IPHONE_X_STATUS_BAR_HEIGHT = 44;
export function getHeight(deviceFrame) {
    if (deviceFrame === deviceFrames.IPHONE_X) {
        return IPHONE_X_STATUS_BAR_HEIGHT;
    }
    return DEFAULT_STATUS_BAR_HEIGHT;
}
